import { deviation } from '@/dataStructures';

export default () => ({
	deviation: deviation(),
	deviationClone: undefined,
	dialogIsShown: false,
	dirty: false,
	deviationLoaded: true,
	resolveFunc: undefined,
	deviationHasChanged: false,
});
